module.exports = __webpack_public_path__ + "media/assets/Pencil-b93cecae084eb86b4c1be5fcae02867a.svg";